export const KINDS = {
  job:         { label: "Job Run",     color: "#0369a1", bg: "#e0f2fe" },
  delivery:    { label: "Delivery",    color: "#c2410c", bg: "#ffedd5" },
  watertest:   { label: "Water Test",  color: "#0f766e", bg: "#ccfbf1" },
  maintenance: { label: "Maintenance", color: "#a16207", bg: "#fef9c3" },
  away:        { label: "Away / Out",  color: "#be123c", bg: "#ffe4e6" },
};
export const KIND_OPTIONS = [["", "Auto-detect"], ...Object.entries(KINDS).map(([k, v]) => [k, v.label]), ["office", "Office (not on board)"]];

export const iso = (d) => d.toLocaleDateString("en-CA");
export const todayISO = () => iso(new Date());
export const mondayOf = (d) => { const x = new Date(d); if (x.getDay() === 0) x.setDate(x.getDate() + 1); const wd = (x.getDay() + 6) % 7; x.setDate(x.getDate() - wd); x.setHours(0, 0, 0, 0); return x; };
export const shiftDays = (isoStr, n) => { const d = new Date(isoStr + "T00:00:00"); d.setDate(d.getDate() + n); return iso(d); };
export const dayLabel = (isoStr) => new Date(isoStr + "T00:00:00").toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" });
export const isSaturday = (isoStr) => new Date(isoStr + "T00:00:00").getDay() === 6;
export const firstName = (n) => (n || "Everyone").split(" ")[0];
// what happened to a finished magnet (it stays on the board as history)
export const outcomeTag = (m) => (m.outcome === "runback" ? `Runback${m.runback_to ? ` to ${m.runback_to.slice(5, 10).split("-").reverse().join("/")}` : ""}` : m.outcome === "quote" ? "Quote" : "Completed");
export const sameName = (a, b) => (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();
export const RUN_STAFF = ["Matthew Kennett", "Luke Price", "Paul Minter"];

const noSun = (d, dir = 1) => (new Date(d + "T00:00:00").getDay() === 0 ? shiftDays(d, dir) : d);
export const VIEWS = { day: "Day", week: "Week", fortnight: "2 Weeks", month: "Month" };

export function rangeFor(view, anchor) {
  if (view === "day") { const d = noSun(anchor); return { start: d, days: 1, label: dayLabel(d) }; }
  if (view === "month") {
    const a = new Date(anchor + "T00:00:00");
    const first = iso(new Date(a.getFullYear(), a.getMonth(), 1));
    const start = iso(mondayOf(new Date(first + "T00:00:00")));
    return { start, days: 42, month: a.getMonth(), label: a.toLocaleDateString("en-AU", { month: "long", year: "numeric" }) };
  }
  const start = iso(mondayOf(new Date(anchor + "T00:00:00")));
  const days = view === "week" ? 7 : 14;
  return { start, days, label: `${dayLabel(start)} – ${dayLabel(shiftDays(start, days - 2))}` };
}

export function stepAnchor(view, anchor, dir) {
  if (view === "day") return noSun(shiftDays(anchor, dir), dir);
  if (view === "month") { const a = new Date(anchor + "T00:00:00"); return iso(new Date(a.getFullYear(), a.getMonth() + dir, 1)); }
  return shiftDays(anchor, dir * (view === "week" ? 7 : 14));
}
